import axios, { type AxiosInstance, type AxiosError } from 'axios'

/**
 * Shared axios instance. Vite dev proxy maps `/api/*` → backend at :8000
 * (see vite.config.ts). In production the SPA and API share the origin, so
 * the same `/api` prefix just works.
 */
export const apiClient: AxiosInstance = axios.create({
  baseURL: '/api/v1',
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
})

/**
 * Whether the backend is reachable. Each store sets this on the first
 * successful / failed request — views fall back to bundled mock data when
 * the backend is unreachable, so the demo site keeps working standalone.
 */
export const apiState = {
  backendReachable: null as boolean | null,
}

apiClient.interceptors.response.use(
  (response) => {
    apiState.backendReachable = true
    return response
  },
  (error: AxiosError) => {
    // Network failure, timeout, or non-2xx — record it so callers can decide
    // whether to swallow + fall back, or surface a toast.
    if (!error.response) apiState.backendReachable = false
    return Promise.reject(error)
  },
)
